import { Box, Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import React from 'react';
import { FaSearch } from 'react-icons/fa';

import { ELEMENT_DATA_TEST_IDS } from '@/tests/testConstants';

interface ControlledSearchProps {
  /** Change handler which accepts a synthetic input event to take action upon */
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** The text to display in the empty input */
  placeholder: string;
  /** The controlled input value of the search box */
  value: string;

  isDisabled?: boolean;
  /** The px width of the search box, defaults to 300px */
  width?: string;
}

const DEFAULT_WIDTH_PX = '250px';

const ControlledSearch = (props: ControlledSearchProps): React.JSX.Element => {
  const { width = DEFAULT_WIDTH_PX } = props;

  return (
    <Box>
      <InputGroup>
        <InputLeftElement pointerEvents={'none'}>
          <FaSearch />
        </InputLeftElement>
        <Input {...props} width={width} data-testid={ELEMENT_DATA_TEST_IDS.CONTROLLED_SEARCH_INPUT}/>
      </InputGroup>
    </Box>
  );
};

export default ControlledSearch;
